function getEnv() {
  return import.meta.env.VITE_ENV_KEY.toLowerCase()
}

function getDomain() {
  return import.meta.env.VITE_APP_COOKIE_DOMAIN
}

function getEnvironmentKey(key) {
  const env = getEnv()

  if (!window._appGroup) throw new Error('appGroup missing!')

  return [key, window._appGroup, env].join('-')
}

export const CookieUtil = {
  delete(key, withinEnv = true) {
    const envKey = withinEnv ? getEnvironmentKey(key) : key
    const domain = getDomain()

    document.cookie = `${envKey}=;domain=${domain};expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;secure`
  },

  deleteAppGroupCookies(appGroups, key) {
    const domain = getDomain()
    appGroups.forEach(group => {
      const envKey = [key, group, domain].join('-')
      document.cookie = `${envKey}=;domain=${domain};expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;secure`
    })
  },

  read(key, withinEnv = true) {
    const envKey = withinEnv ? getEnvironmentKey(key) : key

    return document.cookie
      .split('; ')
      .find(row => row.startsWith(envKey + '='))
      ?.split('=')[1]
  },

  set({ key, value, withinEnv = true, lifetime = 7776000 }) {
    const envKey = withinEnv ? getEnvironmentKey(key) : key
    const domain = getDomain()

    document.cookie = `${envKey}=${value};domain=${domain};max-age=${lifetime};path=/;secure`
  },
}
